import { theme } from '@theme';
import styled from 'styled-components';
import { DealTypeSticker } from '../../style/DealTypeSticker';

export const NotifIcon = styled.div`
  display: inline-flex;
  position: static;
  align-items: center;
  padding: 0 10px 0 8px;

  [class*='am-icon'] {
    position: static;
  }
`;

export const ReadStatus = styled.div`
  padding: 7px 0 0;
`;

export const NotifTextContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  min-height: 72px;
`;

export const DealTypeStickerNotification = styled(DealTypeSticker)<{ isRead?: boolean }>`
  position: unset;
  opacity: 0.85;

  ${(props) =>
    props.isRead
      ? `
    opacity: 1;
    filter: grayscale(90%);
    `
      : ``}
`;

export const ReadControl = styled.div<{ isRead?: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  display: inline-block;
  position: relative;
  background-color: ${theme.palette.purpleTwo};
  &:before {
    content: '';
    position: absolute;
    right: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    background-color: ${theme.palette.white};
  }

  ${(props) =>
    props.isRead
      ? `
      background-color: ${theme.palette.lightPurpleSeven};
      filter: grayscale(90%);
      `
      : `
    &:after {
      content: '';
      position: absolute;
      right: 4px;
      top: 4px;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: ${theme.palette.purpleTwo};
    }
`}
`;

export const Actions = styled.div.attrs({
  className: 'mx-2 pt-3',
})`
  position: unset;
  text-align: center;
  .tooltip {
    white-space: nowrap;
  }
`;
